module.exports = __webpack_public_path__ + "static/media/logout.0ec964e4.png";